import {CheckCircleFillIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useScrollToMergeBox} from '../../mergebox/use-scroll-to-mergebox'
import {useMergeabilityData} from './use-mergeability-data'

// Renders for the author/assignees when the pull request is mergeable ("Ready to merge"),
// offering a shortcut that scrolls to the merge box so they can complete the merge.
export function ReadyToMerge() {
  const data = useMergeabilityData()
  const scrollToMergeBox = useScrollToMergeBox()

  if (!data) {
    return null
  }

  const {mergeBoxPullRequest, mergeRequirements, statusChecksData} = data
  const status = mergeabilityStatus({
    pullRequest: mergeBoxPullRequest,
    mergeRequirements,
    statusChecksData,
  })

  if (status !== Status.Mergeable) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} variant="success" />}
      title="Ready to merge"
      itemName="ready-to-merge"
      actionSlot={
        <Button size="small" onClick={scrollToMergeBox}>
          Go to merge box
        </Button>
      }
    />
  )
}
